export class ActionMenuLabels {
    static HOLDINGS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.HOLDINGS';
    static ACTIVITY = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.ACTIVITY';
    static BALANCES = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BALANCES';
    static PROJ_CASH_FLOW = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.PROJ_CASH_FLOW';
    static HOLDINGS_BY_SYMBOL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.HOLDINGS_BY_SYMBOL';
    static IP_TOTALS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.IP_TOTALS';
    static QUOTES = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.QUOTES';
    static DIGEST = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.DIGEST';
    static OPTION_QUOTE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.OPTION_QUOTE';
    static NEWS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.NEWS';
    static BUY = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY';
    static BUY_MORE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_MORE';
    static SELL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL';
    static SELL_FROM_POSITIONS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_FROM_POSITIONS';
    static SELL_COVERED_CALLS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_COVERED_CALLS';
    static SELL_ALL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_ALL';
    static SELL_SHORT = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_SHORT';
    static BUY_TO_COVER = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_TO_COVER';
    static REDEEM = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.REDEEM';
    static EXCHANGE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.EXCHANGE';
    static BUY_CALLS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_CALLS_TO_OPEN';
    static SELL_CALLS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_CALLS_TO_OPEN';
    static BUY_PUTS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_PUTS_TO_OPEN';
    static SELL_PUTS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_PUTS_TO_OPEN';
    static CLOSE_CALLS_PUTS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CLOSE_CALLS_PUTS';
    static TRADE_AWAY = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.TRADE_AWAY';
    static CFRA_QUICK_VIEW = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CFRA_QUICK_VIEW';
    static ADD_NOTE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.ADD_NOTE';
    static CALCULATE_LOI_ROA = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CALCULATE_LOI_ROA';
    static SELL_POSITIONS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_POSITIONS';
    static PERIODIC_INSTRUCTIONS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.PERIODIC_INSTRUCTIONS';
    static DIVIDEND_REINVEST = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.DIVIDEND_REINVEST';
    static CALCULATE_CDSC = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CALCULATE_CDSC';
}
